module.exports = __webpack_public_path__ + "img/programmer-and-coding-concept.ef77df69.jpeg";